import React from "react";
import "./header.css";
import Logo from "../../../../../assets/images/vct_technologies_logo.png";
import AccountOpening from "../../../../../assets/images/account_opening_nav.svg";
import FundsApproval from "../../../../../assets/images/funds_approval_nav.svg";
import OMS from "../../../../../assets/images/trading_nav.svg";
import Fix from "../../../../../assets/images/fix.svg";
import Dashboard from "../../../../../assets/images/dashboard_nav.svg";
import Profile from "../../../../../assets/images/profile_nav.svg";
import Signout from "../../../../../assets/images/logout_nav.svg";

import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { IsAuthenticated } from "helpers";
import { Logout } from "api-services";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useDispatch, useSelector } from "react-redux";
import MobileNav from "../../MobileNav";

const apiOfferings = [
  {
    name: "Account Opening API",
    description: "Onboard new users",
    imgSrc: AccountOpening,
  },
  {
    name: "Funding API",
    description: "Custom workflows",
    imgSrc: FundsApproval,
  },
  {
    name: "Trading API",
    description: "Trade equities, options, monitor positions",
    imgSrc: OMS,
  },
  {
    name: "FIX Specifications",
    description: "Harness the power of our FIX infrastructure in your products",
    imgSrc: Fix,
  },
];
function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user_data } = useSelector((state) => state.authentication);
  const isAuthenticated = IsAuthenticated();
  const fullName = user_data?.customer?.fullName;

  const handleNavigation = (path) => () => {
    navigate(path);
  };

  const renderApiOffering = ({ name, description, imgSrc }) => (
    <li className="d-flex">
      <img
        src={imgSrc}
        alt={name}
        className="img-fluid mb-5"
        width={30}
        height={30}
      />
      <button
        className="dropdown__link"
        onClick={handleNavigation(
          isAuthenticated ? "/products" : "/authentication/sign-up"
        )}
      >
        {name} <br />
        <span>{description}</span>
      </button>
    </li>
  );
  const LogoLight = Logo;
  const images = {
    Logo,
    LogoLight,
    AccountOpening,
    FundsApproval,
    OMS,
    Dashboard,
    Profile,
    Signout,
    Fix,
  };
  return (
    <div className="wrap-header">
      <div className="container">
        <div className="row">
          <nav className="navbar d-none d-lg-block">
            <div className="navbar__inner container-fluid">
              <div className="navbar__items">
                <Link to="/dashboard" className="navbar-brand">
                  <img src={Logo} alt="Gato Systems" />
                </Link>
              </div>
              <div className="navbar__items navbar__items--right col-4">
                <div className="row justify-content-md-right">
                  <div className="navbar__item dropdown dropdown--hoverable show col-5 pt-1 text-end">
                    <Link to="#" className="navbar__link">
                      API Offerings
                    </Link>
                    <ul className="dropdown__menu dropdown-menu api-offerings">
                      {apiOfferings.map(renderApiOffering)}
                    </ul>
                  </div>
                  {isAuthenticated ? (
                    <div className="navbar__item dropdown dropdown--hoverable show col-7 p-0 pt-1 text-center">
                      <div className="wrap-name">
                        <AccountCircleIcon
                          className="me-2 mb-1 text-white"
                          fontSize="medium"
                        />
                        <Link to="#" className="navbar__link">
                          {fullName}
                        </Link>
                      </div>
                      <ul className="dropdown__menu dropdown-menu af-signin">
                        <li>
                          <img
                            src={Dashboard}
                            alt="Dashboard"
                            className="img-fluid mb-2"
                            width={32}
                            height={32}
                          />
                          <button
                            className="dropdown__link"
                            onClick={handleNavigation("/dashboard")}
                          >
                            Dashboard
                          </button>
                        </li>
                        <li>
                          <img
                            src={Profile}
                            alt="Profile"
                            className="img-fluid mb-2"
                            width={32}
                            height={32}
                          />
                          <button
                            className="dropdown__link"
                            onClick={handleNavigation("/profile")}
                          >
                            Profile
                          </button>
                        </li>
                        <li>
                          <img
                            src={Signout}
                            alt="Signout"
                            className="img-fluid mb-2"
                            width={32}
                            height={32}
                          />
                          <button
                            className="dropdown__link"
                            onClick={() => Logout(dispatch, navigate)}
                          >
                            Sign Out
                          </button>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="navbar__item dropdown dropdown--hoverable col-3 p-0 pt-1 text-center">
                      <button
                        className="navbar__link"
                        onClick={handleNavigation("/authentication/sign-in")}
                      >
                        Sign In
                      </button>
                    </div>
                  )}
                  {!isAuthenticated && (
                    <div className="navbar__item dropdown dropdown--hoverable col-4 p-0">
                      <button
                        className="btn btn-reg"
                        onClick={handleNavigation("/authentication/sign-up")}
                      >
                        Register
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </nav>
          <MobileNav images={images} />
        </div>
      </div>
    </div>
  );
}

export default Header;
